import type { FaireProductEntity } from "../../entity_types/product";

export const p_a4hzwpxnzd: FaireProductEntity = {
  token: "p_a4hzwpxnzd",
  type: "product",
  name: "Resting Face Glassware",
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/ead611ae6a431e00deac8aeb93248602860aac3e7cf27c8513a02a687dee10f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c52c3041cc26be2b80d99a776ee5d2596792276a0e1d0ac3af4c3a51e3c852d.jpeg",
    "https://cdn.faire.com/fastly/aad20eccf5f1c3212a52512ba0c60c75eaf1843be5b129b452fa71f70be15fe4.jpeg",
    "https://cdn.faire.com/fastly/611fac76c6218a734fc678c238efe48860634c496d6e25da9953e005cd0646d0.jpeg",
    "https://cdn.faire.com/fastly/d37f05f7b91c01097b4b2038f763905bdfa91ac3396bfd3e8196f06825f4f462.jpeg",
    "https://cdn.faire.com/fastly/a72e06c2c2bfa88ba59e9f89c5a4800b8bd64ed6d2baaff3d847944cffdfe68b.jpeg",
    "https://cdn.faire.com/fastly/3de89a11bee2db491efab5d85eba2adadd4a5fb1419d4aa77c6af4b25fa633e2.jpeg",
    "https://cdn.faire.com/fastly/16c8c3ccf586c1a20fd2255a0a0cfbee1c29164a884bdb347421a3cf3e9f50af.jpeg",
  ],
  priceDollars: 6.5,
  description:
    "Make your glass as expressive as your favorite vintage with this Resting Face Glassware. Exclusively designed by Abbott, this glass is accented with an impassive, embossed face for a stylish, understated addition to any get-together or hosting occasion. Available as a Wing Goblet, Highball, and Tumbler.",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:05.522Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
